import { useState } from "react";

const DashboardViewModal = () => {
  const [ChartData, setChartData] = useState({
    series: [
      {
        name: "Teachers",
        data: [31, 40, 28, 51, 42, 109, 100, 12, 33],
      },
      {
        name: "Students",
        data: [11, 32, 45, 32, 34, 52, 41, 12, 33],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "area",
        toolbar: {
          tools: {
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "months",
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
    },
  });

  return {
    ChartData,
  };
};

export default DashboardViewModal;
